import React from 'react'
import { usePaginationFragment, graphql } from 'react-relay'

import { GuildList } from '@newComponents/Guild/GuildList'

import { GuildsScreenAllList_query$key } from './__generated__/GuildsScreenAllList_query.graphql'

export const GuildsScreenAllList = ({
  query,
}: {
  query: GuildsScreenAllList_query$key
}) => {
  const { data, hasNext, loadNext } = usePaginationFragment(
    graphql`
      fragment GuildsScreenAllList_query on Query
      @refetchable(queryName: "GuildsScreenAllListPaginationQuery")
      @argumentDefinitions(
        count: { type: "Int", defaultValue: 12 }
        cursor: { type: "Cursor" }
      ) {
        guilds: rankedGuilds(first: $count, after: $cursor)
          @connection(key: "GuildsScreenAllList_query_guilds") {
          ...GuildList_guildsConnection

          edges {
            cursor
          }
        }
      }
    `,
    query
  )

  if (!data.guilds) {
    return null
  }

  return (
    <>
      <GuildList
        guildsConnection={data.guilds}
        itemsPerRow={3}
        hasNext={hasNext}
        loadNext={loadNext}
        display='none'
        $gtLg={{ display: 'flex' }}
      />

      <GuildList
        guildsConnection={data.guilds}
        itemsPerRow={2}
        hasNext={hasNext}
        loadNext={loadNext}
        display='none'
        $gtXs={{ display: 'flex' }}
        $gtLg={{ display: 'none' }}
      />

      <GuildList
        guildsConnection={data.guilds}
        itemsPerRow={1}
        hasNext={hasNext}
        loadNext={loadNext}
        display='flex'
        $gtXs={{ display: 'none' }}
      />
    </>
  )
}
